import services from './../../../services/service'; // Service Class
//import PaymentService from './../../PaymentService/index.vue'; //Payment service
import PaymentService from './../../../pages/PaymentService/index.vue'; //Payment service
import Settings from './../../../resources/setts.js'; //Settings

let service = new services();

export default {
    name: 'Orders',
    mixins: [Settings],
    data () {
        return {
          user: {},
          orders:{},
          order: {},
          order_item:{},
          img_product_url: service.imageProductsURL,
          loading:true,
          show_all:true,
          show_single:false,
          is_new:false,
          show_products_for_review:false,
          data_processing_message:"",
          disable_btn:false,
          action_loading:false,
          star_rates:5,
          componentOrderItemReviewKey:0,
          brokers:{},
          broker_request:{},
          broker_request_payment_data:{},
          show_brokers:false,
          show_order_notifications:false,
          show_payment_service:false,
          show_empty_fields: false,
        }
      },
    components: {
        'component-payment-service': PaymentService,
    },
      
    methods:{
        setOrder(order){
            this.order = order;
            this.show_all = false;
            this.show_single = true;
            this.loading = false;
        },
        viewOrders(){
            this.show_all = true;
            this.show_single =false;
            this.is_new = false; //reset if set
            this.show_products_for_review = false;
        },
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
     
        preset(){
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != null) {
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                    self.loggedIn = true;
                    self.getOrders();
                    if(self.$route.params.ordid != null){
                        self.setSingleOrder(self.$route.params.ckid);
                    }
                    //self.loading = false;
                }else {
                    self.$router.push('login');
                }
            });
           
        },

        getOrders(){
            service.getOrders(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.orders = response.body.data;
                    this.orders.set = true;
                    this.loading = false;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        setSingleOrder(order_no){
            for(let order of orders){
                if(order.order_no == order_no){
                    this.setOrder(order);
                }
            }
        },

        prepareProductsForReview(){
            this.order_item = this.order.order_items[0]; //default pick first
            this.order_item.data_processing_message = "";
            this.order_item.product_item_review = "";
            this.order_item.product_item_rate = 0;
            this.order_item.star_rates = 5;
            this.show_products_for_review = true;
        },

        setRating(i,item_index){
            //reset
            var stars = document.getElementsByClassName('rate-stars');
            for (var n = 0; n < this.order_item.star_rates; n++) {
                stars[n].style = "color:none;";
            } 
            // document.getElementById(i+"STR"+item_index).style.color = "yellow";
            for (var r = 0; r <= i; r++) {
                document.getElementById(r+"STR"+item_index).style.color = "yellow";
            } 
            // document.getElementById(i+"STR"+item_index).style.color = "yellow";
            this.order_item.product_item_rate = (i+1);
            // this.componentOrderItemReviewKey++;
        },

        submitReview(){
            this.order_item.data_processing_message = "";
            if((this.order_item.product_item_review == "") && (this.order_item.product_item_rate == 0)){
            // if((this.order_item.product_item_review == "")){
                this.order_item.data_processing_message = "Please review and rate";
                // this.order_item.data_processing_message = "Please enter the review";
            }else{
                this.activate_processing();
                var payload = {
                    'product_reviewed_by': this.user.user_id,
                    'product_id': this.order_item.product_id,
                    'product_item_id': this.order_item.product_item_id,
                    'product_item_order_cost': this.order_item.order_item_total,
                    'product_review': this.order_item.product_item_review,
                    'product_rate': this.order_item.product_item_rate,
                }
                service.addProductReview(this, payload).then(response => {
                    if(response.body.status == 201) {
                        this.deactivate_processing();
                    }
                }).catch((err) => {})
            }
            this.componentOrderItemReviewKey++;
                
        },

        //send message
        sendMessageToBroker(broker){
            this.activate_processing();
            this.data_processing_message = "";
            //send request to broker
           var payload = {
                request_agent_type: 12, //broker agent
                request_module: 8, //orders
                request_module_id: this.order.order_id,
                request_agent: broker.broker_ref, //agent@appid
                request_sender: this.user.user_id,
                request_message: this.user.user_name+ " requested your Broker Services "
            }
            service.postAgentRequests(this,payload).then(response => {
                if(response.body.status == 201) {
                    //send message and notifications
                    var payload = {
                        message_module: 19, //account
                        message_module_id: 0,
                        message_recipient: broker.broker_ref_id,
                        message_sender: this.user.user_id,
                        message_message: this.user.user_name+ " requested your Broker Services "
                    }
                    service.postMessages(this,payload).then(response => {
                        if(response.body.status == 201) {
                            this.data_processing_message = "Sent, Broker would reply";
                            //this.brokers = response.body.data;
                            this.deactivate_processing();
                        }else{this.deactivate_processing();}
                    }).catch((err) => {
                        this.deactivate_processing();
                        //console.log(err) //possibly a load payment error
                    })
                }else{this.deactivate_processing();}
            }).catch((err) => {
                this.deactivate_processing();
                //console.log(err) //possibly a load payment error
            })
        },

        //brokers
        getActiveBrokers(){
            service.getActiveBrokers(this).then(response => {
                if(response.body.status == 200) {
                    this.brokers = response.body.data;
                    // this.deactivate_processing();
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        setBrokerOrderPaymentData(){
            this.show_empty_fields = false; //redo
            let payment_data = {};
            if((this.user.user_email == undefined) || (this.user.user_phone == undefined) || (this.user.user_email == "") || (this.user.user_phone == "")){
                this.show_empty_fields = true;
            }else{
                payment_data = {
                    payer_name: this.user.user_name,
                    payer_email: this.user.user_email,
                    payer_phone: this.user.user_phone,
                    payment_total_amount: this.broker_request.broker_request_fee,
                    payment_currency: "NGN", //default //can change from form
                    // pay_payment_ref: this.broker_request.broker_request_ref+Math.floor(Math.random() * 5),
                    payment_ref: this.broker_request.broker_request_ref,
                    payment_details: "Broker Agent Fee Payment For: "+this.broker_request.broker_request,
                    payment_processing_fee_status:4, //buyer pays
                    payment_processing_fee:(service.app_proc_fee_calc * this.broker_request.broker_request_fee), //using default 13% proc fee
                    payment_processing_fee_transaction_type:4, //buyer pays
                    pay_transaction_type: 2, //agent fee payment
                   // pay_transaction_module_id: this.broker_request_ref_no,
                    payment_module: 22, //agent requests
                    payment_module_id: this.broker_request_ref_no,
                    payment_data_index: 0, //default
                    payment_data_route: "orders",
                    payment_service_business:0, //not a buisness
                    payment_sub_accounts: [], //no sub accounts
                    payment_meta: []
                }
                this.show_empty_fields = false;
            }
            this.broker_request_payment_data = payment_data;
        }
            
    },
    created(){
       // document.title = "Orders" + " | "+service.app_name;
        //clear/remove if order stored in local forage
        localforage.removeItem("not_loggedin_processed_orders").then(function (value) {}).catch(function(err) {});
        if(this.$route.params.ordid != null){
            this.show_all = false;
            this.show_single = true;
            this.is_new = true;
        }
        this.getActiveBrokers();
        this.preset();
    }
     
}


// WEBPACK FOOTER //
// ./src/components/order/Orders/script.js